import React from "react";
import VIPLargeCard from "../../../../../components/VIPLargeCard";
import approvedInvoicesLogo from "../../../../../assets/images/approvedInvoices.png";
import { useGetApprovedInvoiceToday } from "../../InvoiceCapture/hooks/useGetApprovedInvoiceToday";

interface Props {}
export const TotalInvoiceApprovedCard: React.FC<Props> = () => {
  const { data: approvedInvoiceToday } = useGetApprovedInvoiceToday();
  return (
    <>
      <VIPLargeCard
        title={"Total Number of Invoices Approved Today"}
        count={approvedInvoiceToday?.data?.map((x) => ({ ...x })).length}
        className={"bg-quinary border border-gray-200 shadow-md rounded-md"}
        src={approvedInvoicesLogo}
      />
    </>
  );
};
